import React from 'react';
interface BonusCardProps {
  image: string;
  title: string;
  description: string;
  number: number;
}
export function BonusCard({
  image,
  title,
  description,
  number
}: BonusCardProps) {
  return <div className="bg-white rounded-xl overflow-hidden shadow-lg border border-gray-100 flex flex-col h-full transform hover:scale-105 transition-transform duration-300" data-id="element-1">
      <div className="relative" data-id="element-2">
        <div className="absolute top-0 right-0 bg-yellow-500 text-blue-900 font-bold px-3 py-1 text-sm rounded-bl-lg z-10" data-id="element-3">
          BONUS #{number}
        </div>
        <img src={image} alt={title} className="w-full h-64 object-contain bg-gray-50 p-4" data-id="element-4" />
      </div>
      <div className="p-6 flex-1 flex flex-col" data-id="element-5">
        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6">{title}</h3>
        <p className="text-gray-600 text-sm flex-1" data-id="element-7">{description}</p>
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-8">
          <span className="inline-block bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded uppercase tracking-wide" data-id="element-9">
            Gratis por el día de hoy
          </span>
        </div>
      </div>
    </div>;
}